import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import StickyMobileCTA from "@/components/StickyMobileCTA";
import DiwaliPopup from "@/components/DiwaliPopup";

export default function PublicLayout({ children }) {
  return (
    <>
      <Navbar />
      <main>{children}</main>
      <Footer />
      <StickyMobileCTA />
      <DiwaliPopup />
    </>
  );
}
